import React, { useEffect } from "react";

interface SuccessPopupProps {
    handlepopup: boolean;
    message?: string;
    onClose?: () => void;
}

const SuccessPopup: React.FC<SuccessPopupProps> = ({ handlepopup, message = 'Success', onClose }) => {
    useEffect(() => {
        if (handlepopup && onClose) {
            const timeout = setTimeout(() => {
                onClose();
            }, 2000);
            return () => clearTimeout(timeout);
        }
    }, [handlepopup, onClose]);

    if (!handlepopup) return null;

    return (
        <div 
            className="fixed inset-0 bg-black/30 backdrop-blur-sm z-50 flex items-center justify-center"
            data-testid="success-popup"
        >
            <div 
                className="bg-white p-6 py-[40px] rounded-lg shadow-lg flex flex-col items-center w-[90%] sm:w-[320px]"
                data-testid="success-popup-container"
            >
                <div>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="130"
                        height="130"
                        viewBox="0 0 130 130"
                        fill="none"
                        data-testid="success-icon"
                    >
                        <circle cx="65" cy="65" r="65" fill="#CCE1D4" />
                        <circle opacity="0.3" cx="65" cy="65" r="49" fill="#0C612C" />
                        <circle cx="64.9974" cy="65.0013" r="30.3333" fill="#0C612C" />
                        <path d="M61.528 69.1999L57.0105 64.6824L55.4722 66.2099L61.528 72.2658L74.528 59.2658L73.0005 57.7383L61.528 69.1999Z" fill="white" />
                    </svg>
                </div>
                <p className="text-[18px] font-medium text-black pt-4">{message}</p>
            </div>
        </div>
    );
}; 

export default SuccessPopup;